module.exports = __webpack_public_path__ + "img/vertical_7_1_8017.dab4b50a.png";